import { isDefined } from "@clipboard-health/util-ts";
import {
  ShiftChipTypes,
  type ShiftChipAdditionalData,
  type ShiftChipType,
} from "@src/appV2/Calendar/ShiftChips/types";
import {
  shouldShowUrgentChip,
  shouldShowStillBookableChip,
} from "@src/appV2/Calendar/ShiftChips/utils";
import { Shift } from "@src/interface";
import { parseISO } from "date-fns";
import { EventType } from "./type";

export function getShiftChips(shift: Shift) {
  const shiftChips: Array<{ type: ShiftChipType; additionalData?: ShiftChipAdditionalData }> = [];

  if (shift.isMagicShift) {
    shiftChips.push({ type: ShiftChipTypes.MAGIC });
  }

  if (
    shouldShowUrgentChip({
      shift,
      isMagicShift: isDefined(shift.isMagicShift) && shift.isMagicShift,
    })
  ) {
    shiftChips.push({ type: ShiftChipTypes.URGENT });
  }

  if (shouldShowStillBookableChip(shift)) {
    shiftChips.push({
      type: ShiftChipTypes.STILL_BOOKABLE,
      additionalData: {
        extendedBookabilityTo: parseISO(shift.extendBookabilityTo),
        facilityTimeZone: shift.facility?.tmz,
      },
    });
  }

  return shiftChips;
}

export function getEventBackgroundColor(type: EventType): string {
  switch (type) {
    case "creation":
      return "#e3f2fd"; // light blue
    case "opened":
      return "#f3e5f5"; // light purple
    case "booked":
      return "#e8f5e9"; // light green
    case "clockin":
      return "#e3f2fd"; // light blue
    case "clockout":
      return "#fff3e0"; // light orange
    case "payment":
      return "#e8f5e9"; // light green
    case "rate":
      return "#fffde7"; // light yellow
    case "cancel":
      return "#ffebee"; // light red
    case "unassign":
      return "#fff3e0"; // light orange
    case "note":
      return "#e8eaf6"; // light indigo
    case "shift_spec":
      return "#e1f5fe"; // light cyan
    case "priority":
      return "#f3e5f5"; // light purple
    case "magic":
      return "#ede7f6"; // light deep purple
    default:
      return "#f5f5f5"; // light grey
  }
}
